'use client'

import { twMerge } from '@/lib/classname/twMerge'
import { type TableBodyProps, TableBody as AriaTableBody } from 'react-aria-components'

export function TableBody<T extends object>({ className, ...props }: TableBodyProps<T>) {
  return <AriaTableBody {...props} className={twMerge('', className)} />
}
